import styled, { css } from 'styled-components';
import { KeyboardDatePicker as ActualKeyboardDatePicker } from '@material-ui/pickers';

const followUp = css`
  font-size: 15px;
  line-height: 1.5;
  letter-spacing: 0.2px;
`;

const caseOpening = css`
  font-size: 16px;
  line-height: 1.13;
  letter-spacing: normal;
`;

export const KeyboardDatePicker = styled(ActualKeyboardDatePicker)`
  > div {
    height: 50px;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.inputBorderColor};
    border-radius: 4px;

    input {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 150%;
      color: ${({ theme }) => theme.textPrimary};
    }
  }
`;

export const DatePickerTitle = styled.p`
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  margin: 0;
  ${props => (props.caseCreationCustomStep ? caseOpening : followUp)}
`;
